import { FC, AnchorHTMLAttributes } from 'react';
import cn from 'classnames';

import { useI18n } from '@catawiki/cata-style';

import LogoHuge from './logo-huge.svg';
import styles from './BrandLogo.module.scss';
import { SmallLogo } from './SmallLogo';

export interface Props extends AnchorHTMLAttributes<HTMLAnchorElement> {
  alt?: string;
  small?: boolean;
}

export const BrandLogo: FC<Props> = ({ small, className, alt, ...props }) => {
  const i18n = useI18n();

  return (
    <a
      className={cn(styles.wrapper, className, { [styles.small]: small })}
      title={alt ?? i18n.t('catawiki')}
      {...props}
    >
      <img
        className={styles.logo}
        src={LogoHuge.src}
        aria-hidden="true"
        alt=""
      />
      <SmallLogo
        className={cn(styles['small-logo'], 'tw:w-full')}
        aria-hidden="true"
        alt=""
      />
    </a>
  );
};
